$(() => {
  //Ensure styling corresponds to whether radio input is checked or not
  $("input[type='radio'].onetime_subscribe_radio").change(function() {
    $("input[type='radio'].onetime_subscribe_radio:not(:checked)").parent().parent().removeClass("radio-checked");
    $("input[type='radio'].onetime_subscribe_radio:checked").parent().parent().addClass("radio-checked");
  });

  //Let click in div containing radio act as click on radio itself
  $('.radio-option-outer[data-toggle="collapse"]').on('click',function(e){
    if (e.target === e.currentTarget) {
      $(e.target).find(".radio-option-inner").click()
    }
    if ( $(this).parents('.accordion').find('.collapse.show') ){
      const idx = $(this).index('.radio-option-outer[data-toggle="collapse"]');
      if (idx == $('.collapse.show').index('.collapse')) {
        e.stopPropagation();
      }
    }
  })

  let urlParams = new URLSearchParams(window.location.search);
  $("input[name='return_to']").val(`/cart?${urlParams.toString()}`)
})


function waitForFlagr() {

  //Make sure that external script https://s3-us-west-2.amazonaws.com/static.becausemarket.com/jsExperiments/jsExperimentBundle-1.1.10.js loads before attempting A/B test
  if (!window.Flagr) {
    return setTimeout(waitForFlagr, 100)
  }

  //console.log("evaluating variant");
  //Get variant randomly (flag key is passed to evaluateFlag)
  window.Flagr.evaluateFlag('cta_accordion_default_subscribe', (error, result) => {
    if (error) {
      console.log(error)
      trackEvent("BW AB - PDP Accordion Choice", { "section": ":input.onetime_subscribe_radio", "defaultToSubscribe": false, "error": error })
      $("#default-onetime-accordion").show();
      $("#default-subscribe-accordion").remove();
      return
    }

    //Wait 5 attempts for the relevant input to load
    const clickOrDont = (selector, defaultToSubscribe, retry = 0) => {
      if (retry === 5) {
        console.error(`failed to find ${selector} for 5 time, enable default`)
        trackEvent("BW AB - PDP Accordion Choice", {
          "section": selector,
          "defaultToSubscribe": false,
          "error": "section not found in 5 attempts"
        })
        $("#default-onetime-accordion").show();
        $("#default-subscribe-accordion").remove();
        return
      }

      //console.log("selector=",selector);
      //console.log("variant? ",defaultToSubscribe);

      //Wait till input selector loads
      if ($(selector).length === 0) {
        //console.log("no selector found");
        return setTimeout(() => clickOrDont(selector, defaultToSubscribe, retry++), 100)
      }

      //For mixpanel; see whether funnel beginning with shouldClick=true leads to to more subscriptions
      trackEvent("BW AB - PDP Accordion Choice", { "section": selector , "defaultToSubscribe": defaultToSubscribe})

      if (defaultToSubscribe) {
        // console.log("received true");
        $("#default-subscribe-accordion").show();
        $("#default-onetime-accordion").remove();
      } else {
        // console.log("received false");
        $("#default-onetime-accordion").show();
        $("#default-subscribe-accordion").remove();
      }
    }

    //See schema for variantAttachment object at https://stage-flagr.becausemarket.com/#/flags/17
    //ctaSectionSelector is always ":input.onetime_subscribe_radio"
    //and defaultSubscribe is distributed between true or false
    clickOrDont(result.variantAttachment.ctaSectionSelector,result.variantAttachment.defaultToSubscribe)
  })
}

$('.radio-option-outer[data-toggle="collapse"]').on('click',function(e){
  if ( $(this).parents('.accordion').find('.collapse.show') ){
    var idx = $(this).index('.radio-option-outer[data-toggle="collapse"]');
    if (idx == $('.collapse.show').index('.collapse')) {
      e.stopPropagation();
    }
  }
})

waitForFlagr()
